import { useEffect, useState } from "react";
import { getCountryList, getGenderList, getMemberTypeList, getRoles, getSearchArtistList, saveMember } from "../../actions/user";
import TableCard, { CardData as TableCardData, headerItem } from '../../components/cards/TableCard';
import SearchMember from "../../components/search-forms/searchMember";
import { MemberModal } from "../../components/modals/member";
import { Pagination } from "../../components/pagination";
import { Actions, friendlyDate } from "../../utils";
import { GLOBAL_URLS } from "../../constants";
import useAuth from "../../hooks/useAuth";
import { Backend } from "shared-types";

const MembersPage = () => {
    const { user } = useAuth() as any;
    const [memberModel, setMemberModel] = useState<any>({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const [memberTableData, setMemberTableData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [timer, setTimer] = useState<any>();
    const [genderList, setGenderList] = useState<any>([]);
    const [countryList, setCountryList] = useState<any>([]);
    const [roleList, setRoleList] = useState<Backend.T_MemberRole[]>([]);
    const [memberTypeList, setMemberTypeList] = useState<any>([]);

    useEffect(() => {
        getMemberTypeList({}).then((res: any) => {
            setMemberTypeList(res.result);
        });
        getGenderList({}).then((res: any) => {
            setGenderList(res.result);
        });
        getCountryList({}).then((res: any) => {
            setCountryList(res?.countries);
        });
        getRoles().then((res: any) => {
            setRoleList(res)
        })
    }, []);

    const [formData, setFormData] = useState<any>({
        pagination: {
            page: 0,
            pages: 0,
            size: 10,
            total: 0
        },
        filter: {
            keyword: "",
            client: [2],
            role: [],
            type: [],
        }
    });

    const [resData, setResData] = useState<any>({
        pagination: {
            page: 0,
            pages: 0,
            size: 10,
            total: 0
        },
        title: "",
        list: [],
        filtered: {
            client: [],
            role: [],
            type: [],
        }
    });

    useEffect(() => {
        let filter = {
            client: user.client?.id ? [user.client.id] : [2],
            keyword: formData.filter.keyword,
            role: formData.filter.role,
            type: formData.filter.type,
        };
        setFormData({ ...formData, filter: filter });
    }, [user.client]);


    const loadData = () => {
        setLoading(true);
        setResData({
            ...resData,
            pagination: {
                ...resData.pagination,
                pages: 0,
            },
            title: '',
        });
        getSearchArtistList(formData).then((res: any) => {
            setLoading(false);
            setResData({
                ...res.result,
                title: `found ${res.result.pagination.total.toLocaleString().toString().replace(/,/g, ', ')} results`,
            });
            const result: TableCardData[] = [];
            for (let i = 0; i < res.result.list.length; i++) {
                result.push({
                    id: res.result.list[i].id,
                    icon: `https://img.cugate.com/?i=${res.result.list[i].id}&o=member`,
                    data: [
                        {
                            title: `<a onclick='window.open("${GLOBAL_URLS.MEMBER_DETAIL_URL + res.result.list[i].id}");'>${res.result.list[i].used_name == 2 ? res.result.list[i].alias : res.result.list[i].title}</a>`,
                        },
                        {
                            cell: res.result.filtered.client.filter((c: any) => c.id === res.result.list[i].register_from).length ?
                                res.result.filtered.client.filter((c: any) => c.id === res.result.list[i].register_from)[0].title : '',
                        },
                        {
                            cell: res.result.filtered.role.filter((c: any) => c.id === res.result.list[i].standard_role_id).length ?
                                res.result.filtered.role.filter((c: any) => c.id === res.result.list[i].standard_role_id)[0].title : '',
                        },
                        {
                            cell: res.result.filtered.type.filter((c: any) => c.id === res.result.list[i].member_type_id).length ?
                                res.result.filtered.type.filter((c: any) => c.id === res.result.list[i].member_type_id)[0].title : '',
                        },
                        {
                            cell: friendlyDate(res.result.list[i].register_date),
                        },
                        {
                            cell: friendlyDate(res.result.list[i].update_time),
                        },
                    ]
                })
            }
            setMemberTableData(result);
        });
    };

    useEffect(() => {
        clearTimeout(timer);
        setTimer(setTimeout(
            () => {
                loadData()
            }, 500
        ));
    }, [formData]);

    const handleMemberEditAction = (id: number) => {
        let member = resData.list?.filter((l: any) => l.id === id);
        member = member.length ? member[0] : {};
        setMemberModel({
            validate: true,
            ...member,
            avatar: `https://img.cugate.com/?i=${member.id}&o=member`,
            action: Actions.edit,
            message: "",
        });
        setShowModal(true);
    };

    const handleMemberDeleteAction = (id: number) => {
        let member = resData.list?.filter((l: any) => l.id === id);
        member = member.length ? member[0] : {};
        setMemberModel({
            id: id,
            validate: true,
            ...member,
            avatar: `https://img.cugate.com/?i=${member.id}&o=member`,
            action: Actions.delete,
            message: "",
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    }

    const handleMemberSaveAction = async (event: { currentTarget: any; preventDefault: () => void; stopPropagation: () => void; }) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false || (memberModel.avatar === null || memberModel.avatar === "") && memberModel.action === Actions.add) {
            event.stopPropagation();
            setMemberModel({ ...memberModel, validate: false, message: '' });
        } else {
            setMemberModel({ ...memberModel, validate: true, message: '' });
            saveMember({
                ...memberModel,
                action: memberModel.action === Actions.add ? "add" : memberModel.action === Actions.edit ? "edit" : "delete",
            }).then((res: any) => {
                if (res.result.status) {
                    setMemberModel({
                        ...memberModel,
                        message: res.result.message,
                        validate: true,
                    });
                } else {
                    loadData();
                    setShowModal(false);
                }

            })
        }
    };

    const handleClient = (client: number) => {
        let list = [];
        formData.filter.client.forEach((g: number) => {
            if (client !== g) list.push(g);
        });
        if (!formData.filter.client.filter((g: number) => g === client).length) {
            list.push(client);
        }
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                client: list
            }
        });
    };

    const handleRole = (role: number) => {
        let list = [];
        formData.filter.role.forEach((g: number) => {
            if (role !== g) list.push(g);
        });
        if (!formData.filter.role.filter((g: number) => g === role).length) {
            list.push(role);
        }
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                role: list
            }
        });
    };

    const handleType = (type: number) => {
        let list = [];
        formData.filter.type.forEach((g: number) => {
            if (type !== g) list.push(g);
        });
        if (!formData.filter.type.filter((g: number) => g === type).length) {
            list.push(type);
        }
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                type: list
            }
        });
    };

    const handleKeyword = (e: any) => {
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                keyword: e.target.value
            }
        });
    }

    const handlePage = (page: number) => {
        setFormData({
            ...formData,
            pagination: {
                ...formData.pagination,
                page: page,
            }
        });
    };

    return (
        <div className="page page-label mb-5">
            <SearchMember
                data={{
                    client: formData.filter.client,
                    role: formData.filter.role,
                    type: formData.filter.type,
                    clientList: resData.filtered.client,
                    roleList: resData.filtered.role,
                    typeList: resData.filtered.type,
                    handleClient: handleClient,
                    handleRole: handleRole,
                    handleType: handleType,
                }}
            />
            <div className="">
                <div className="uk-container-large">
                    <div className="search-component search-form">
                        <div className="container uk-container-large">
                            <div className="bg-white border border-white rounded d-flex justify-content-between align-items-center">
                                <input
                                    placeholder="Search artists, composers"
                                    className="border border-white form-control search-track-input"
                                    onChange={handleKeyword}
                                    value={formData.filter.keyword}
                                />
                                <img
                                    src="/imgs/search.svg"
                                    className="me-2 py-2 focus"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                    <TableCard
                        title={resData.title}
                        loading={loading}
                        icon={true}
                        danger={true}
                        filterable={false}
                        className={`member-table w-100`}
                        actions={[Actions.edit, Actions.delete]}
                        data={memberTableData}
                        headers={[
                            headerItem("Title"),
                            headerItem("Name"),
                            headerItem("Role"),
                            headerItem("Type"),
                            headerItem("Created At", '109px'),
                            headerItem("Updated At", '110px'),
                        ]}
                        onClickEdit={handleMemberEditAction}
                        onClickDelete={handleMemberDeleteAction}
                    />
                    <Pagination
                        pagination={resData.pagination}
                        handlePage={handlePage}
                        className={"mt-4"}
                    />
                    <MemberModal
                        mkey={"member-edit"}
                        show={showModal}
                        model={memberModel}
                        setModel={setMemberModel}
                        closeModal={handleCloseModal}
                        memberTypeList={memberTypeList}
                        saveModal={handleMemberSaveAction}
                        genderList={genderList}
                        countryList={countryList}
                        roleList={roleList}
                    />
                </div>
            </div>
        </div>
    )
}

export default MembersPage;